<h1 mat-dialog-title>Transferir Presidência</h1>

<form [formGroup]="form" (ngSubmit)="confirmar()">
  <div mat-dialog-content class="dialog-content">
    <div *ngIf="carregando" class="loading-container">
      <mat-spinner diameter="32"></mat-spinner>
    </div>

    <div *ngIf="!carregando && titulares.length === 0" class="empty-message">
      <mat-icon>info</mat-icon>
      <span>Nenhum titular disponível para transferência.</span>
    </div>

    <mat-form-field appearance="fill" class="w-100" *ngIf="!carregando && titulares.length > 0">
      <mat-label>Novo Presidente</mat-label>
      <mat-select formControlName="novoPresidenteId">
        <mat-option *ngFor="let t of titulares" [value]="t.id">
          {{ t.nome }}<span *ngIf="t.titulacao"> — {{ t.titulacao }}</span><span *ngIf="t.titulacaoData"> (obtido em {{ t.titulacaoData | date:'yyyy' }})</span>
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('novoPresidenteId')?.hasError('required')"> Selecione um titular </mat-error>
    </mat-form-field>
  </div>

  <div mat-dialog-actions>
    <button mat-button type="button" (click)="cancelar()">Cancelar</button>
    <button mat-flat-button color="primary" type="submit"
      [disabled]="form.invalid || carregando || enviando || titulares.length === 0">
      {{ enviando ? 'Transferindo...' : 'Confirmar' }}
    </button>
  </div>
</form>
